module.exports = __webpack_public_path__ + "img/shengxianshuiguo.4ba70a90.png";